/**
 * /auth/signed-out — landing screen after a deliberate sign-out. Never
 * redirects on mount; `signInAgain` fires `redirectToCentralizedLogin` only
 * on click.
 */
import { Box, Button, Stack, Typography } from '@mui/material';
import { PreAppLayout } from '@/components/PreAppLayout';
import { useCopy } from '@/hooks/useCopy';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { usePageTitle } from '@/components/page/usePageTitle';

export function SignedOut() {
  const { t } = useCopy();
  const heading = t('auth.signedOutTitle', "You're signed out");
  usePageTitle(heading);

  function signInAgain(): void {
    redirectToCentralizedLogin('/');
  }

  return (
    <PreAppLayout>
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          px: 2,
        }}
      >
        <Stack spacing={2} sx={{ alignItems: 'center' }}>
          <Typography variant="h2" component="h1">
            {heading}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 480 }}>
            {t('auth.signedOutBody', 'Your product-admin session has ended.')}
          </Typography>
          <Button variant="outlined" onClick={signInAgain}>
            {t('auth.signInAgain', 'Sign in again')}
          </Button>
        </Stack>
      </Box>
    </PreAppLayout>
  );
}
